module.exports = __webpack_public_path__ + "static/media/schedule.56035a03.svg";